import "core-js/modules/es.array.reverse.js";
var _class, _CzmlTimeVaryingStratum, _dec, _dec2, _dec3, _class2, _descriptor, _CzmlCatalogItem;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, observable, toJS, makeObservable } from "mobx";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import CzmlDataSource from "terriajs-cesium/Source/DataSources/CzmlDataSource";
import isDefined from "../../../Core/isDefined";
import TerriaError, { networkRequestError } from "../../../Core/TerriaError";
import AutoRefreshingMixin from "../../../ModelMixins/AutoRefreshingMixin";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import CzmlCatalogItemTraits from "../../../Traits/TraitsClasses/CzmlCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import CommonStrata from "../../Definition/CommonStrata";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import CesiumIonMixin from "../../../ModelMixins/CesiumIonMixin";

/**
 * A loadable stratum for CzmlCatalogItemTraits that derives TimeVaryingTraits
 * from the CzmlDataSource
 */
let CzmlTimeVaryingStratum = (_class = (_CzmlTimeVaryingStratum = class CzmlTimeVaryingStratum extends LoadableStratum(CzmlCatalogItemTraits) {
  constructor(catalogItem) {
    super();
    this.catalogItem = catalogItem;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new CzmlTimeVaryingStratum(model);
  }
  get clock() {
    var _this$catalogItem$_da;
    return (_this$catalogItem$_da = this.catalogItem._dataSource) === null || _this$catalogItem$_da === void 0 ? void 0 : _this$catalogItem$_da.clock;
  }
  get currentTime() {
    var _this$clock;
    const currentTime = (_this$clock = this.clock) === null || _this$clock === void 0 ? void 0 : _this$clock.currentTime;
    return currentTime ? JulianDate.toIso8601(currentTime) : undefined;
  }
  get startTime() {
    var _this$clock2;
    const startTime = (_this$clock2 = this.clock) === null || _this$clock2 === void 0 ? void 0 : _this$clock2.startTime;
    return startTime ? JulianDate.toIso8601(startTime) : undefined;
  }
  get stopTime() {
    var _this$clock3;
    const stopTime = (_this$clock3 = this.clock) === null || _this$clock3 === void 0 ? void 0 : _this$clock3.stopTime;
    return stopTime ? JulianDate.toIso8601(stopTime) : undefined;
  }
  get multiplier() {
    var _this$clock4;
    return (_this$clock4 = this.clock) === null || _this$clock4 === void 0 ? void 0 : _this$clock4.multiplier;
  }
}, _defineProperty(_CzmlTimeVaryingStratum, "stratumName", "czmlLoadableStratum"), _CzmlTimeVaryingStratum), _applyDecoratedDescriptor(_class.prototype, "clock", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "clock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "startTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stopTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "stopTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "multiplier", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "multiplier"), _class.prototype), _class);
StratumOrder.addLoadStratum(CzmlTimeVaryingStratum.stratumName);
let CzmlCatalogItem = (_dec = computed({
  equals: JulianDate.equals
}), _dec2 = computed({
  equals: JulianDate.equals
}), _dec3 = computed({
  equals: JulianDate.equals
}), _class2 = (_CzmlCatalogItem = class CzmlCatalogItem extends AutoRefreshingMixin(MappableMixin(UrlMixin(CesiumIonMixin(CatalogMemberMixin(CreateModel(CzmlCatalogItemTraits)))))) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "_dataSource", _descriptor, this);
    makeObservable(this);
  }
  get type() {
    return CzmlCatalogItem.type;
  }
  setFileInput(file) {
    this.setTrait(CommonStrata.user, "url", URL.createObjectURL(file) + "#" + file.name);
  }
  get hasLocalData() {
    var _this$url$startsWith, _this$url;
    return (_this$url$startsWith = (_this$url = this.url) === null || _this$url === void 0 ? void 0 : _this$url.startsWith("blob:")) !== null && _this$url$startsWith !== void 0 ? _this$url$startsWith : false;
  }
  forceLoadMapItems() {
    const attribution = this.attribution;
    let loadableData = undefined;
    if (isDefined(this.czmlData)) {
      loadableData = toJS(this.czmlData);
    } else if (isDefined(this.czmlString)) {
      loadableData = JSON.parse(this.czmlString);
    } else if (isDefined(this.ionResource)) {
      loadableData = this.ionResource;
    } else if (isDefined(this.url)) {
      loadableData = proxyCatalogItemUrl(this, this.url, this.cacheDuration);
    }
    if (loadableData === undefined) {
      throw new TerriaError({
        sender: this,
        title: i18next.t("models.czml.unableToLoadItemTitle"),
        message: i18next.t("models.czml.unableToLoadItemMessage")
      });
    }
    return CzmlDataSource.load(loadableData, {
      credit: attribution
    }).then(action(czmlDataSource => {
      this._dataSource = czmlDataSource;
      this.strata.set(CzmlTimeVaryingStratum.stratumName, new CzmlTimeVaryingStratum(this));
    })).catch(e => {
      if (e instanceof TerriaError) {
        throw e;
      } else {
        throw networkRequestError({
          sender: this,
          title: i18next.t("models.czml.errorLoadingTitle"),
          message: i18next.t("models.czml.errorLoadingMessage")
        });
      }
    });
  }
  forceLoadMetadata() {
    return this.loadIonResource();
  }
  get mapItems() {
    if (this.isLoadingMapItems || this._dataSource === undefined) {
      return [];
    }
    this._dataSource.show = this.show;
    return [this._dataSource];
  }
  get currentTimeAsJulianDate() {
    return toJulianDate(this.currentTime);
  }
  get startTimeAsJulianDate() {
    return toJulianDate(this.startTime);
  }
  get stopTimeAsJulianDate() {
    return toJulianDate(this.stopTime);
  }

  /**
   * Reloads CzmlDataSource if the source is a URL
   * Required for AutoRefreshingMixin
   */
  refreshData() {
    var _this$_dataSource;
    if (this.url === undefined) return;
    const url = proxyCatalogItemUrl(this, this.url, this.cacheDuration);
    (_this$_dataSource = this._dataSource) === null || _this$_dataSource === void 0 || _this$_dataSource.process(url);
  }
}, _defineProperty(_CzmlCatalogItem, "type", "czml"), _CzmlCatalogItem), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "_dataSource", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "setFileInput", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setFileInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasLocalData", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasLocalData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mapItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentTimeAsJulianDate", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "currentTimeAsJulianDate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "startTimeAsJulianDate", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "startTimeAsJulianDate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "stopTimeAsJulianDate", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "stopTimeAsJulianDate"), _class2.prototype), _class2);
export { CzmlCatalogItem as default };
function toJulianDate(time) {
  return time === undefined || time === null ? undefined : JulianDate.fromIso8601(time);
}